// priceRules.js

const priceRules = [
    {
      id: "sideLite",
      formula: "((doorData.frameData.sideLiteSize * doorData.frameData.frameHeight)/144) * <<price1>>",
      price1: ["ref_sideLiteFramePrice", "doorData.sideLite.sideLiteOptionsS_label"],
      price2: ["Gentek", "doorData.frameData.frameColor"],
      unitPrice: 7,
      multiplicator: {
        condition: "doorData.frameData.selectedDoor?.id === 4 || doorData.frameData.selectedDoor?.id === 8",
        value: 2
      }
    },
    {
      id: "sideLiteGlass",
      formula: "((doorData.frameData.sideLiteSize * doorData.frameData.frameHeight)/144) * <<price1>>",
      price1: [`ref_sideLiteGlass`, "doorData.sideLite.sideLiteOptionsS_label"],
      unitPrice: 1,
      minValue: 0
    },
    { id: "ref_transomGlass", Clear: 0, Sandblasted: 20, Delta: 25 },
    { id: "ref_sideLiteGlass", Clear: 0, Sandblasted: 20, Delta: 25 },
    { id: `ref_sideLiteFramePrice`, Clear: 10, Sandblasted: 10, Delta: 10 },
    { id: `ref_doorGlass`, Clear: 0, Sandblasted: 20, Delta: 25 },
    { id: `ref_framePrice`, Clear: 10, Sandblasted: 10, Delta: 10 },
    { id: `ref_sillOptions`, Standard: 0, Handicap: 30 },
    {
      id: "sillOptions",
      formula: "<<price1>>",
      price1: [`ref_sillOptions`, "doorData.frameData.sillOptions"],
      unitPrice: 1,
      minValue: 0,
      conditionalPrice: {
        condition1: "doorData.frameData.selectedDoor?.id > 4 && doorData.frameData.frameSizeCustom === '5' && doorData.frameData.sillOptions === 'Handicap'",
        unitPrice1: 0,
        value1: 305,
        condition2: "doorData.frameData.selectedDoor?.id > 4 && doorData.frameData.frameSizeCustom === '6' && doorData.frameData.sillOptions === 'Handicap'",
        unitPrice2: 0,
        value2: 375,
      }
    },
    {
      id: "retractableScreen",
      formula: "<<price1>>",
      price1: [`ref_sillOptions`, "doorData.frameData.sillOptions"],
      unitPrice: 1,
      minValue: 0,
      conditionalPrice: {
        condition1: "doorData.frameData.selectedDoor?.id > 4 && doorData.frameData.frameSizeCustom === '5'",
        unitPrice1: 0,
        value1: 720,
        condition2: "doorData.frameData.selectedDoor?.id > 4 && doorData.frameData.frameSizeCustom === '6'",
        unitPrice2: 0,
        value2: 770,
      }
    },
    {
      id: "doorGlass",
      formula: "((doorData.frameData.frameWidth * doorData.frameData.frameHeight)/144) * <<price1>>",
      price1: [`ref_doorGlass`, "doorData.doorLite.optionsS_label"],
      unitPrice: 1,
      minValue: 0
    },
    {
      id: "frameSize",
      formula: "((doorData.frameData.frameWidth * doorData.frameData.frameHeight)/144) * <<price1>>",
      formula1: "((doorData.frameData.frameWidth * doorData.frameData.frameHeight)/144) * <<price1>>",
      price1:  [`ref_framePrice`, "doorData.doorLite.optionsS_label"],
      price11: [`ref_doorGlass`, "doorData.doorLite.optionsS_label"],

      unitPrice: 10,
      minValue: 2,
      conditionalPrice: {
        condition1: "doorData.frameData.selectedDoor?.id > 4 && doorData.frameData.frameSizeCustom === '5' && doorData.frameData.swing === 'Inswing'",
        unitPrice1: 0,
        value1: 2950,
        condition2: "doorData.frameData.selectedDoor?.id > 4 && doorData.frameData.frameSizeCustom === '6' && doorData.frameData.swing === 'Inswing'",
        unitPrice2: 0,
        value2: 3265,

        condition3: "doorData.frameData.selectedDoor?.id > 4 && doorData.frameData.frameSizeCustom === '5' && doorData.frameData.swing === 'Outswing'",
        unitPrice3: 0,
        value3: 3765,
        condition4: "doorData.frameData.selectedDoor?.id > 4 && doorData.frameData.frameSizeCustom === '6' && doorData.frameData.swing === 'Outswing'",
        unitPrice4: 0,
        value4: 4407,
      }
    },
    {
      id: "transom",
      formula: "(doorData.transomData.transomW * doorData.transomData.transomH)/144",
      unitPrice: 200,
      minValue: 1
    },
    {
      id: "transomGlass",
      formula: "((doorData.transomData.transomW * doorData.transomData.transomH)/144) * <<price1>>",
      price1: [`ref_transomGlass`, "doorData.transomData.transomGlass_label"],
      unitPrice: 1,
      minValue: 0
    },
    {
      id: "doorGrills",
      formula: "(Number(doorData.doorLite.glassDividersHorizontal || -1) + 1) * (Number(doorData.doorLite.glassDividersVertical || 0) + 1)",
      unitPrice: 10,
      minValue: 0,
      multiplicator: {
        condition: "doorData.frameData.selectedDoor?.id > 4",
        value: 2
      }
    },
    {
      id: "sideLiteGrills",
      formula: "(Number(doorData.sideLite.glassDividersHorizontal || -1) + 1) * (Number(doorData.sideLite.glassDividersVertical || 0) + 1)",
      unitPrice: 10,
      minValue: 0,
      multiplicator: {
        condition: "(doorData.frameData.selectedDoor?.id === 4) || (doorData.frameData.selectedDoor?.id === 8)",
        value: 2
      }
    },
    {
      id: "hinges",
      formula: null,
      unitPrice:0.0,
      minValue: null
    },

    { id: `ref_CascadingCombo`, 'Key Lock for Tilt and Turn': 400, 'Installation': 1000, B: 40, C: 50 },
    {
      id: "CascadingCombo1",
      formula: "<<price1>>",
      price1: [`ref_CascadingCombo`, "doorData.additionalItems.CascadingCombo1"],
      unitPrice: 1,
      minValue: 0
    },
    {
      id: "CascadingCombo2",
      formula: "<<price1>>",
      price1: [`ref_CascadingCombo`, "doorData.additionalItems.CascadingCombo2"],
      unitPrice: 1,
      minValue: 0
    },
    {
      id: "CascadingCombo3",
      formula: "<<price1>>",
      price1: [`ref_CascadingCombo`, "doorData.additionalItems.CascadingCombo3"],
      unitPrice: 1,
      minValue: 0
    },
    {
      id: "CascadingCombo4",
      formula: "<<price1>>",
      price1: [`ref_CascadingCombo`, "doorData.additionalItems.CascadingCombo4"],
      unitPrice: 1,
      minValue: 0
    },
    {
      id: "CascadingCombo5",
      formula: "<<price1>>",
      price1: [`ref_CascadingCombo`, "doorData.additionalItems.CascadingCombo5"],
      unitPrice: 1,
      minValue: 0
    },
    {
      id: "ExteriorDoorGentek",
      formula: null,
      unitPrice: 600,
      minValue: null
    },
    {
      id: "InteriorDoorGentek",
      formula: null,
      unitPrice: 600,
      minValue: null
    },
    {
      id: "ScreenFrameColorGentek",
      formula: "<<price1>>",
      price1: ["", "doorData.sideLite.sideLiteOptionsS_label"],
      unitPrice: 255.5,
      minValue: null,
        conditionalPrice: {
        condition1: "doorData.frameData.selectedDoor?.id > 4 && doorData.frameData.frameSizeCustom === '5'",
        unitPrice1: 0,
        value1: 170,
        condition2: "doorData.frameData.selectedDoor?.id > 4 && doorData.frameData.frameSizeCustom === '6'",
        unitPrice2: 0,
        value2: 170,
      }
    },
    {
      id: "doorGrillsExteriorGentek",
      formula: null,
      unitPrice: 25,
      minValue: null
    },
    {
      id: "doorGrillsInteriorGentek",
      formula: null,
      unitPrice: 35,
      minValue: null
    },
    {
      id: "sideLiteGrillsExteriorGentek",
      formula: null,
      unitPrice: 25,
      minValue: null
    },
    {
      id: "sideLiteGrillsInteriorGentek",
      formula: null,
      unitPrice: 35,
      minValue: null
    },
  ];
  
  export default priceRules;
  